import { render, staticRenderFns } from "./LinkBlock.vue?vue&type=template&id=0b5b7f14&"
import script from "./LinkBlock.vue?vue&type=script&lang=js&"
export * from "./LinkBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports